module.exports = __webpack_public_path__ + "img/about02.fd84b4ea.png";